<template>
	<div>
		<div class="current-values" v-for="(child, index) in children.user_children" :key="child.id">
			<h3>Hijo o hija {{index+1}}</h3>
			<div class="ctn-action-btns">
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon  small @click="child.editableFlag = !child.editableFlag"  class="mr-2" v-bind="attrs" v-on="on">
							<span icon color="primary" small class="action-btn edit-pencil"></span>
						</v-btn>
					</template>
					<span>Editar</span>
				</v-tooltip>
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon small @click="deleteChild(child)" v-bind="attrs" v-on="on">
							<span icon color="primary" small class="action-btn remove-can"></span>
						</v-btn>
					</template>
					<span>Eliminar</span>
				</v-tooltip>
			</div>
			<br/>
			<v-form
					:ref="'form'+index"
					v-model="child.valid"
					lazy-validation
			>
				<label for="">Nombres</label>
				<v-text-field
						:disabled="child.editableFlag"
						v-model="child.names"
						:rules="validationRules.required"
						placeholder=""
						required
				></v-text-field>
				<label for="">Apellidos</label>
				<v-text-field
						:disabled="child.editableFlag "
						v-model="child.surnames"
						:rules="validationRules.required"
						placeholder=""
						required
				></v-text-field>
				<label for="">Fecha y hora de nacimiento</label>
				<v-datetime-picker
						:disabled="child.editableFlag"
						v-model="child.birth_date"
						:rules="validationRules.required"
						dateFormat="yyyy-MM-dd"
						timeFormat="HH:mm:ss"
						placeholder=""
						required
						:max="maxDate">
					<template slot="actions" slot-scope="{ parent }">
						<v-btn text color="primary" @click="parent.okHandler">OK</v-btn>
					</template>
					<template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
					<template slot="timeIcon"><v-icon>mdi-timer</v-icon></template>
				</v-datetime-picker>
				<label for="">País de nacimiento</label>
				<v-autocomplete
						:disabled="child.editableFlag"
						v-model="child.born_country"
						:items="countries"
						item-text="country"
						item-value="country"
						placeholder="Selecciona un pais"
						:rules="validationRules.required"
				></v-autocomplete>
				<label for="">Estado o departamento de nacimiento</label>
				<v-autocomplete
						v-model="child.born_place"
						:items="countries2[child.born_country]"
						menu-props="auto"
						:rules="validationRules.required"
						placeholder="Selecciona un estado"
						required
						:disabled="child.editableFlag || !countries2[child.born_country]"
				></v-autocomplete>
				<v-btn v-if="!child.editableFlag" outlined color="primary" class="save-btn" @click="child.editableFlag = !child.editableFlag">
					Cancelar
				</v-btn>
				<v-btn color="primary" v-if="!child.editableFlag" class="save-btn ml-4" @click="updateChildAction(child, index)" :disabled="!child.valid || !child.birth_date">
					Guardar cambios
				</v-btn>
			</v-form>
		</div>
		<div class="new-child" v-if="newChild.flag">
			<h3>Agregar hijo {{children.user_children.length + 1}}</h3>
			<v-form
					ref="newForm"
					v-model="newChild.valid"
					lazy-validation
			>
				<label for="">Nombres</label>
				<v-text-field
						v-model="newChild.names"
						:rules="validationRules.required"
						placeholder=""
						required
				></v-text-field>
				<label for="">Apellidos</label>
				<v-text-field
						v-model="newChild.surnames"
						:rules="validationRules.required"
						placeholder=""
						required
				></v-text-field>
				<label for="">Fecha de nacimiento</label>
				<v-datetime-picker
						v-model="newChild.birth_date"
						:rules="validationRules.required"
						dateFormat="yyyy-MM-dd"
						timeFormat="HH:mm:ss"
						placeholder=""
						required>
					<template slot="actions" slot-scope="{ parent }">
						<v-btn text color="primary" @click="parent.okHandler">OK</v-btn>
					</template>
					<template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
					<template slot="timeIcon"><v-icon>mdi-timer</v-icon></template>
				</v-datetime-picker>
				<label for="">País de nacimiento</label>
				<v-autocomplete
						v-model="newChild.born_country"
						:items="countries"
						item-text="country"
						item-value="country"
						placeholder="Selecciona un pais"
						required
						:rules="validationRules.required"
				></v-autocomplete>
				<label for="">Estado o departamento de nacimiento</label>
				<v-autocomplete
						v-model="newChild.born_place"
						:items="states[0].states"
						:rules="validationRules.required"
						placeholder="Selecciona un estado"
						required
						:disabled="!states[0].country"
				></v-autocomplete>
			</v-form>
			<v-btn color="primary" outlined class="save-btn" @click="newChild.flag = false">
				Cancelar
			</v-btn>
			<v-btn color="primary" class="save-btn ml-4" @click="saveNewChild" :disabled="!newChild.valid || !newChild.birth_date">
				Guardar cambios
			</v-btn>
		</div>
		<div class="ctn-btn" v-if="!newChild.flag">
			<v-btn fab color="teal" dark small @click="addChild">
				<v-icon dark>mdi-plus</v-icon>
			</v-btn>
			<label @click="addChild">Agregar</label>
		</div>
		<v-dialog v-model="dialog" persistent max-width="350">
			<v-card>
				<v-card-title class="headline">Eliminar registro</v-card-title>
				<v-card-text>
					¿Realmente desea eliminar el registro?
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="confirmDeleteChild(currentChild.id)">Borrar</v-btn>
					<v-btn color="gray" text @click="dialog = false">Cancelar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import {phones} from "../assets/js/phones.js"
  import {countries} from "../assets/js/countries.js"
  import {countries2} from "../assets/js/countries2.js"
  export default {
    name: "Children.vue",
		data() {
      return {
        birth_date: "2020-08-05 09:20:00",
        phones: phones,
        countries: countries,
        countries2: countries2,
        userChild: {
          number: 1,
          user_children: []
        },
        newChild: {
          names: "",
          flag: false
        },
				showConfirm: false,
        dialog: false,
        currentChild: {},
				validationRules: {
          required: [
            v => !!v || 'Debe ingresar un valor para este campo',
          ],
				},
				maxDate: new Date()
			}
		},
    computed: {
      ...mapState('child',[
        'children']),
      states() {
        let country = countries.filter((item) => { return item.country == this.newChild.born_country})
        if (!country.length) { country = [{}]}
        return country
      },
		},
		methods : {
      ...mapActions(
          'child', [
            'fetchChildren',
            'removeChild',
            'addUserChild',
						'updateChild',
					]
			),
      ...mapActions(['loaderChange']),
      addChild() {
        this.newChild.flag = true
      },
      saveNewChild () {
        let valid = this.$refs.newForm.validate()
        if (valid) {
          this.loaderChange(true)
          this.addUserChild(this.newChild).finally(() => {
            this.loaderChange(false)
            this.newChild.flag = false
            this.resetNewChild()
          })
        }
      },
      resetNewChild() {
        this.newChild.names = ""
        this.newChild.surnames = ""
        this.newChild.birth_date = ""
        this.newChild.born_country = ""
        this.newChild.born_place = ""
      },
      editChild (child) {
        child.editableFlag = false
			},
      deleteChild(child) {
				this.currentChild = child
				this.dialog = true
			},
			confirmDeleteChild(child) {
        this.dialog = false
        this.loaderChange(true)
        this.removeChild(child).finally(() => {
          this.loaderChange(false)
				})
			},
			updateChildAction (child, index) {
        let valid = this.$refs[`form${index}`][0].validate()
				if (valid) {
					this.loaderChange(true)
					this.updateChild(child).finally(() => {
						this.loaderChange(false)
						child.editableFlag = true
					})
        }
			}
		},
		mounted() {
      this.fetchChildren()
    }
  }
</script>

<style lang="scss" scoped>
	$breakpoints: (
			'tablet': 768px,
	);
	@mixin mobile {
		@media screen and (max-width: map-get($breakpoints, tablet)) {
			@content;
		}
	}
	::v-deep .v-input {
		width: 250px;
		.v-messages__message {
			padding-top: 3px;
		}
		&.v-input--is-disabled {
			.v-input__slot::before {
				display: none;
			}
			.v-input__append-inner {
				display: none;
			}
			.v-text-field__details {
				display: none;
			}
		}
		.v-text-field__details {
			min-height: 0;
			.v-messages, .v-text-field__details {
				min-height: 0;
			}
		}
		.v-input__slot {
			margin-bottom: 0;
		.v-text-field__slot, .v-select__selections {
			input, .v-select__selection {
				color: #656565;
			}
		}
	}

	}
	::v-deep .v-date-picker-header__value button {
		text-transform: uppercase;
		font-size: 14px;
		margin-top: 2px;
	}
	.ctn-btn {
		font-weight: 200;
		margin-top: 20px;
		::v-deep .v-btn {
			background-color: #2C8886;
		}
		label {
			margin-left: 12px;
			vertical-align: middle;
			font-weight: 200;
		}
	}
	.save-btn {
		margin: 35px 0 20px;
		text-transform: none;
		font-size: 14px;
		width: 160px;
		border-radius: 7px;
		height: 40px;
		&.cancel {
			margin-left: 12px;
		}

		@include mobile {
			display: block;
			margin: 4px auto;
			&.cancel {
				margin-left: auto;
			}
		}
	}
	h3	{
		font-size: 16px;
		font-weight: 800;
		margin-bottom: 8px;
		margin-top: 12px;
		color: #656565;
	}
	.current-values {
		position: relative;
		display: inline-block;
		width: 100%;
		.ctn-action-btns {
			display: inline-block;
			position: absolute;
			top: 8px;
			right: 0;
		}
	}
	::v-deep .v-picker__body {
		width: 100% !important;
		.accent--text button, td .v-btn__content {
			color: #656565;
		}
	}
	.save-btn.ml-4 {
		@include mobile {
			margin-left: auto !important;
		}
	}
</style>
